var _path, _rect, _rect2, _use, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path0, _path1, _path10, _g2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g3, _g4, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGbNir = function SvgGbNir(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 640 480"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v480H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    fillRule: "evenodd",
    rx: 0,
    ry: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "gb-nir_svg__a",
    width: 640,
    height: 96,
    y: 192,
    fill: "#c00",
    fillRule: "evenodd",
    rx: 0,
    ry: 0
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gb-nir_svg__a",
    width: 600,
    height: 300,
    transform: "matrix(0 .75 -1 0 560 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebeae3",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M355.2 146.6c3-4.8 1.2-8-3.4-8.9 0 0-14.9 4.8-31 5.3-16 .5-35-4-35-4-3.5 2.1-2.7 7.2-1 10.4 0 0 16.8 5.6 36 5a111 111 0 0 0 30.1-5.5c3.7-1.2 4.3-2.2 4.3-2.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#161111",
    strokeWidth: 1.6,
    d: "m320 357.6-30.9-64.2-70.9 5.4 40-58.8-40-58.8 71 5.4 30.8-64.1 30.9 64 70.9-5.3-40 58.8 40 58.8-71-5.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#b02320",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.3,
    d: "M319.5 122.2c38.8 6.4 37.4 8.2 37.4 8.2l10.1-30.2s1.1-6-1.7-9.6-10.5-1.6-10.5-1.6-1-4.9-4.5-6c-3.4-1.2-16 4.5-20 5.8s-6 2.5-11.5 2.4c-5.5 0-15.4-5-17.3-6-1.7-.9-4.4-1.8-6.9-1.7-2.4 0-5 .7-6.3 2.4s-1.2 3.9-1.2 3.9-2-1.3-5.2-1.3-5 .4-6.5 2.1-3.4 6.5-3.4 6.5l3.6 8.2.2 11.3 7.5 12z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebeae3",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M355.7 139.3s2 2.3 1.9 3.2c-.1.8-1 1.5-1 1.5s.7.6.5 1.5-1.4 1-1.4 1 .3.8-.5 1.2c-.7.4-3.8 1-3.8 1s-15-4.2-31-4.2-35 5.2-35 5.2-2-.7-2-2c-.2-1.2.1-2.1.1-2.1s-1 0-1.3-.9c-.4-1.3.1-2.3.1-2.3s-.7.2.1-1.5c.6-1.3 1.5-1.7 1.5-1.7s16.8-6 36-6.1 35.8 6 35.8 6.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.1,
    d: "M276.2 101.5s-.6-2.2.8-4.1a4 4 0 0 1 4.7-1.4c.8.4.7 1.3 1.7 1.5 1 .3 1.8-.5 1.8-.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillOpacity: 0.9,
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m369.8 106.6-5.8 12-2.3.4s-1.4-.8-5.4-.5c-2.8.2-3.7 1-3.7 1l5.2-12s.4 2.5 1 4c.8 2 3.7 3.7 3.7 3.7s.4-2.3-.4-5a56 56 0 0 0-2.8-7.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#121116",
    stroke: "#121116",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M316.5 69.2h6.5v27.7h-6.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6ca1f",
    fillRule: "evenodd",
    stroke: "#000",
    d: "m276.6 120.2 4.1 9s17.9-7 38.9-6.8c31.5.2 40.5 6.5 40.5 6.5l4.6-11.1-3.5 2-3.6 2.3-4 1.5-5-.3-4.4-3.2-2.2-4.7-3.7 3.4-6.6 1.4-6.4-1.6-5.6-7.1s-4.2 7.9-9.6 8.4c-7.7.6-12.1-3.7-12.1-3.7s-2.9 6.4-7.6 7.5c-7.5 1.9-13.7-3.5-13.8-3.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M348.4 65.7c0 1.8-1.4 3.4-3.3 3.4a3.4 3.4 0 0 1-3.4-3.4 3.4 3.4 0 0 1 3.4-3.5 3.4 3.4 0 0 1 3.3 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M343.5 67.4s2.7 0 3-1.1-.2-2.6-.2-2.6 1.3 1.4 1 2.5q-.5 1.4-1.7 1.7a3 3 0 0 1-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M340.3 69.5c0 1.8-1.5 3.4-3.4 3.4a3.4 3.4 0 0 1-3.4-3.4A3.4 3.4 0 0 1 337 66a3.4 3.4 0 0 1 3.4 3.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M335.3 71.2s2.8 0 3-1.1-.2-2.6-.2-2.6 1.3 1.5 1 2.6q-.5 1.4-1.7 1.6a3 3 0 0 1-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M358 63.4c0 1.9-1.6 3.4-3.4 3.4a3.4 3.4 0 0 1-3.4-3.4 3.4 3.4 0 0 1 3.3-3.4 3.4 3.4 0 0 1 3.4 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M353 65.2s2.7 0 3-1.2-.2-2.5-.2-2.5 1.3 1.4 1 2.5q-.5 1.5-1.7 1.6a3 3 0 0 1-2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M368.6 65.6c0 1.8-1.5 3.4-3.3 3.4a3.4 3.4 0 0 1-3.4-3.4 3.4 3.4 0 0 1 3.4-3.4 3.4 3.4 0 0 1 3.3 3.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M363.7 67.3s2.7 0 3-1.1-.2-2.6-.2-2.6 1.3 1.4 1 2.6q-.5 1.3-1.7 1.6a3 3 0 0 1-2.1-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M376.8 72.3c0 1.8-1.5 3.4-3.4 3.4a3.4 3.4 0 0 1-3.4-3.4 3.4 3.4 0 0 1 3.4-3.4 3.4 3.4 0 0 1 3.4 3.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M371.9 74s2.7 0 3-1.1-.2-2.6-.2-2.6 1.3 1.5.9 2.6q-.4 1.4-1.7 1.6-1 .1-2-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M380.3 83.3c0 1.9-1.5 3.4-3.4 3.4a3.4 3.4 0 0 1-3.3-3.4 3.4 3.4 0 0 1 3.3-3.4 3.4 3.4 0 0 1 3.4 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M375.4 85s2.7 0 3-1.1-.2-2.6-.2-2.6 1.3 1.5.9 2.6q-.4 1.4-1.7 1.6a3 3 0 0 1-2-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M379 94.4c0 2-1.5 3.4-3.4 3.4a3.4 3.4 0 0 1-3.3-3.3 3.4 3.4 0 0 1 3.3-3.5 3.4 3.4 0 0 1 3.4 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M374 96.2s2.8 0 3-1.2c.3-1-.1-2.5-.1-2.5s1.3 1.4.9 2.5-.7 1.4-1.7 1.6a3 3 0 0 1-2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M374 104.2c0 1.9-1.5 3.4-3.3 3.4a3.4 3.4 0 0 1-3.4-3.4 3.4 3.4 0 0 1 3.4-3.4 3.4 3.4 0 0 1 3.3 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M369.1 106s2.7 0 3-1.2c.3-1-.2-2.5-.2-2.5s1.3 1.4 1 2.5q-.5 1.5-1.7 1.6a3 3 0 0 1-2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M332.3 72.4c0 1.9-1.5 3.4-3.3 3.4a3.4 3.4 0 0 1-3.4-3.4 3.4 3.4 0 0 1 3.3-3.4 3.4 3.4 0 0 1 3.4 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M327.4 74.2s2.7 0 3-1.2-.2-2.5-.2-2.5 1.3 1.4 1 2.5q-.5 1.5-1.7 1.6-1.2.3-2.1-.4"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.7
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M322.1 71.5a3 3 0 0 1-2.8 2.9 3 3 0 0 1-2.8-2.9 3 3 0 0 1 2.8-2.8 3 3 0 0 1 2.8 2.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M318 73s2.3 0 2.5-1-.1-2-.1-2 1 1.1.8 2q-.5 1.3-1.4 1.4a3 3 0 0 1-1.8-.4"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.7
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M322.2 75a3 3 0 0 1-2.8 3 3 3 0 0 1-2.8-3 3 3 0 0 1 2.8-2.8 3 3 0 0 1 2.8 2.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M318 76.5s2.3 0 2.6-1c.2-.8-.2-2-.2-2s1 1.2.8 2q-.3 1.3-1.4 1.4a3 3 0 0 1-1.7-.4z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.7
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M322.4 80.3a3 3 0 0 1-2.8 2.8 3 3 0 0 1-2.9-2.8 3 3 0 0 1 2.9-2.9 3 3 0 0 1 2.8 2.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M318.3 81.8s2.2 0 2.5-1-.2-2.1-.2-2.1 1 1.2.8 2q-.3 1.4-1.4 1.4a3 3 0 0 1-1.7-.3"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M322.7 85.8a3 3 0 0 1-3 3.1 3 3 0 0 1-3.1-3 3 3 0 0 1 3-3.2 3 3 0 0 1 3 3.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M318.2 87.4s2.5 0 2.7-1-.2-2.3-.2-2.3 1.2 1.3.9 2.3c-.4 1-.7 1.2-1.5 1.4a3 3 0 0 1-1.9-.4"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M323 93.3c0 1.8-1.5 3.4-3.4 3.4a3.4 3.4 0 0 1-3.3-3.4 3.4 3.4 0 0 1 3.3-3.5 3.4 3.4 0 0 1 3.4 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M318 95s2.8 0 3-1.1-.1-2.6-.1-2.6 1.3 1.5.9 2.6c-.4 1-.7 1.4-1.7 1.6a3 3 0 0 1-2-.5z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M322.7 108.5c0 1.8-1.4 3.2-3.2 3.2a3 3 0 0 1-3.2-3.2c0-1.7 1.4-3.2 3.2-3.2a3 3 0 0 1 3.2 3.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M318 110.2s2.6 0 2.8-1.1c.3-1-.1-2.4-.1-2.4s1.2 1.3.8 2.4q-.4 1.3-1.5 1.5-1 .1-2-.4"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M313.6 72.3c0 1.9-1.6 3.4-3.4 3.4a3.4 3.4 0 0 1-3.4-3.4 3.4 3.4 0 0 1 3.4-3.4 3.4 3.4 0 0 1 3.4 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M308.6 74s2.7 0 3-1c.3-1.2-.2-2.6-.2-2.6s1.3 1.4 1 2.5q-.5 1.5-1.7 1.6a3 3 0 0 1-2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M305.2 69c0 1.9-1.5 3.4-3.4 3.4a3.4 3.4 0 0 1-3.3-3.4 3.4 3.4 0 0 1 3.3-3.4 3.4 3.4 0 0 1 3.4 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M300.3 70.8s2.7 0 3-1.2c.2-1-.2-2.5-.2-2.5s1.3 1.4 1 2.5c-.5 1.1-.8 1.4-1.8 1.6q-1 .3-2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M297.2 65.3c0 1.8-1.5 3.4-3.3 3.4a3.4 3.4 0 0 1-3.4-3.4 3.4 3.4 0 0 1 3.3-3.5 3.4 3.4 0 0 1 3.4 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M292.3 67s2.7 0 3-1.1-.2-2.6-.2-2.6 1.3 1.5 1 2.6q-.5 1.4-1.7 1.6a3 3 0 0 1-2.1-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M288 63.3c0 1.9-1.4 3.4-3.3 3.4a3.4 3.4 0 0 1-3.4-3.4 3.4 3.4 0 0 1 3.4-3.5 3.4 3.4 0 0 1 3.4 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M283.1 65s2.7 0 3-1.1-.2-2.6-.2-2.6 1.3 1.5 1 2.6q-.5 1.4-1.7 1.6a3 3 0 0 1-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M277.2 65.8c0 2-1.5 3.4-3.3 3.5a3.4 3.4 0 0 1-3.4-3.4 3.4 3.4 0 0 1 3.4-3.5 3.4 3.4 0 0 1 3.3 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M272.3 67.6s2.7 0 3-1.1-.2-2.6-.2-2.6 1.3 1.4 1 2.5q-.5 1.4-1.7 1.7a3 3 0 0 1-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M269.6 73.5c0 1.9-1.5 3.4-3.4 3.4a3.4 3.4 0 0 1-3.3-3.4 3.4 3.4 0 0 1 3.3-3.4 3.4 3.4 0 0 1 3.4 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M264.7 75.2s2.7 0 3-1.1-.2-2.6-.2-2.6 1.3 1.5.9 2.6q-.4 1.4-1.7 1.6a3 3 0 0 1-2-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M266.4 84.2c0 1.9-1.5 3.4-3.3 3.4a3.4 3.4 0 0 1-3.4-3.4 3.4 3.4 0 0 1 3.3-3.4 3.4 3.4 0 0 1 3.4 3.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M261.5 86s2.7-.1 3-1.2-.2-2.6-.2-2.6 1.3 1.5 1 2.6q-.5 1.4-1.7 1.6a3 3 0 0 1-2.1-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M267.8 95.3c0 2-1.5 3.5-3.3 3.5a3.4 3.4 0 0 1-3.4-3.4 3.4 3.4 0 0 1 3.3-3.5 3.4 3.4 0 0 1 3.4 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M262.9 97.1s2.7 0 3-1.2c.3-1-.2-2.5-.2-2.5s1.3 1.4 1 2.5q-.5 1.5-1.7 1.7a3 3 0 0 1-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M273 105.5c0 1.8-1.5 3.4-3.4 3.4a3.4 3.4 0 0 1-3.3-3.4 3.4 3.4 0 0 1 3.3-3.5 3.4 3.4 0 0 1 3.4 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M268 107.2s2.8 0 3-1.1-.1-2.6-.1-2.6 1.3 1.4 1 2.5q-.6 1.5-1.7 1.7a3 3 0 0 1-2.1-.5z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.31597 -.08466 .13499 .50378 109.4 30)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M276.3 120.7s1.6-.5 1.5-1.6c0-1.1-.7-2.4-.7-2.4s1.1 1.1 1.2 2.3q0 1.4-.6 1.8-.6.3-1.4-.1"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.31758 .0784 -.125 .50636 260 -40.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M362.3 119.8s1.7.4 2.1-.7c.5-1 .5-2.5.5-2.5s.5 1.6 0 2.6-.8 1.3-1.4 1.3q-.7 0-1.2-.7"
  })))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3a192",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m316.7 53.8.3 5.7s-6.8.6-7 1.2c-1.4 3 1.5 7 1.5 7s2.3-1.8 8-1.8c5.5 0 8.3 1.4 8.3 1.4s1.4-2.3 1.4-4-.6-3.4-.6-3.4l-3.6-.4h-2.5l-.2-5.8z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0ddcb",
    stroke: "#121116",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M326.4 62.6q-.2 1.1-1.2 1.2-1.2-.1-1.3-1.1.2-1.1 1.2-1.2 1.1.1 1.3 1.1m2.7.7q0 1-1.2 1.2c-1.2.2-1.3-.6-1.3-1.2q.1-1.1 1.3-1.2t1.2 1.2m-5.5-.7q-.2 1-1.2 1.2-1.1-.2-1.2-1.2 0-1.3 1.1-1.2t1.3 1.2m-5.6 0q-.1 1.2-1.3 1.3-1.1-.1-1.2-1.2t1.2-1.2c1.2-.1 1.3.5 1.3 1.2m-3.1.2q-.1 1-1.3 1.2-1.1 0-1.2-1.2c-.1-1.2.5-1.2 1.2-1.2s1.3.5 1.3 1.2m5.7-3.5q-.1 1-1 1a1 1 0 0 1-1.2-1q.1-1 1.1-1t1 1m0-4.7q0 .9-1 1a1 1 0 0 1-1-1q0-1 1-1c1 0 1 .4 1 1m0 2.5q0 1-1 1c-1 0-1-.4-1-1q0-.9 1-1c1-.1 1 .4 1 1m-8.8 6.5q0 1.1-1.2 1.2-1 0-1.2-1.2 0-1 1.2-1.1c1.2-.1 1.2.5 1.2 1.1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#916c68",
    stroke: "#4d3126",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M320.9 62.4q-.1 1.1-1.4 1.2a1.3 1.3 0 0 1-1.3-1.2q.1-1.2 1.3-1.3 1.2.1 1.3 1.3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M322 45.5a2.5 2.5 0 0 1-2.4 2.5 2.5 2.5 0 0 1-2.5-2.5 2.5 2.5 0 0 1 2.5-2.6 2.5 2.5 0 0 1 2.5 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M318.4 46.8s2 0 2.2-1c.2-.7-.1-1.8-.1-1.8s1 1 .7 1.9q-.4 1-1.2 1.2a2 2 0 0 1-1.6-.3"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M280 130.1s2.2 2.1 2.8 4 1.5 6.8 1.5 6.8 23.2-6.5 34.6-6 37.7 6.3 37.7 6.3l1-5.7c.5-3 2.7-6.3 2.7-6.3s-25.1-7.8-41-7a116 116 0 0 0-27.3 3.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M314.7 36h10s-2.5 1.7-3 3.4c-.4 1.4-.3 3.7-.3 3.7s2.7 0 4-1l3.7-2.9v12.7s-2.5-2.3-4-3.1a14 14 0 0 0-3.5-1.3s0 2 .8 3.3 4.3 5.8 4.3 5.8l-14.3.5s3.4-3.5 4.8-6.1c.9-1.7.5-3.5.5-3.5s-2.4 0-3.6.9-3.4 3.3-3.4 3.3V39.5s1 2.4 3 3.3 3.8.4 3.8.4.4-2.4-.4-4c-.8-1.5-2.6-3.2-2.4-3.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#121116",
    strokeWidth: 1.2,
    d: "M313.9 76.5s-7.1-.1-13.2-3.7-12.3-7.4-21.3-5.3c-1.8.5-8.6 3.5-11.6 13.2a26 26 0 0 0 2.4 18.7 50 50 0 0 0 5.6 7.4l3.7-2.5s-9.3-8-8.2-18.2c1-10.3 6.2-12.7 6.2-12.7s6.4-5 14.9-.3a80 80 0 0 0 25.3 8.7c.6-.1-4-5.4-3.8-5.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m274.5 115-3.8-7.4 11.4-4.4s-2.8 3.6-3.4 6.2c-.8 3.2-.5 5.9-.5 5.9s1-.8 2.3-2.9c1-1.5 2.6-7.3 2.6-7.3l5.1 16.3s-2.6-2.6-4.5-2.9c-2-.4-4.6.3-4.6.3l-3 1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#121116",
    strokeWidth: 1.2,
    d: "M326.7 76.3s7.1 0 13.2-3.7c6.1-3.6 12.2-7.3 21.3-5.2 1.8.4 8.6 3.4 11.6 13.1a26 26 0 0 1-2.5 18.7l-3.6 5.9-4.4-1.6s8.1-7.3 7-17.6-6.2-12.7-6.2-12.7-6.4-5-14.9-.2-16.8 6.8-16.8 6.8-7.8 2-8.5 1.8c-.7 0 4-5.4 3.8-5.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    stroke: "#121116",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M323 69.3h3V97h-3zm-10-.2h3.5v27.7H313z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    stroke: "#121116",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M329.2 62.7c0 5-4.3 9-9.7 9s-9.7-4-9.7-9 4.3-8.9 9.6-8.9c5.4 0 9.8 4 9.8 8.9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#000",
    d: "m310.9 96.8 16.7-.2s-2 1.2-3.7 4.2c-1.6 3-1.4 4.8-1.4 4.8s2.5 0 4.3-1.3a26 26 0 0 0 3.8-3.7v15.3s-1.3-2-3.3-3c-2-1.3-4.8-1.3-4.8-1.3h-5.7s-2.6.2-3.7 1a29 29 0 0 0-3.7 3.2l-.3-14.6s.8 2.6 3.5 3.6 4.2 1 4.2 1 0-3.4-1.4-5a33 33 0 0 0-4.5-4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6ca1f",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.9,
    d: "M320.2 108.8s2.4 5.7 5.3 8.2c1.6 1.5 6.6 2.6 8.8 2 5-1.3 8.6-5.3 8.6-5.3s-.2 4.4 3 6.9q4.5 3.5 8.2 2.3c2.7-.7 10-6.2 10-6.2l1.6 1.3s-4.3 4.2-8.7 6.3c-2.3 1.2-9.3.5-11.5-1.3-2.3-1.8-3.6-6.1-3.6-6.1s-1.4 2.8-4.4 3.8-7 1-10.9-.2c-2.5-.8-5.9-4.3-6.5-5.5-.6-1.1-.4-1.8-.4-1.8s-2 5.4-5.8 6.9a19 19 0 0 1-11.5.4c-3.6-1-3.9-3.1-3.9-3.1s-.2 5.7-8 7.3c-8 1.6-14.2-4.1-14.2-4.1l1.1-1.7s4.4 5 11.2 4.6 9-9.2 9-9.2 3 4.5 11 4.6 10.2-10.3 10.2-10.3z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fc0",
    stroke: "#000",
    strokeWidth: 1.1
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M300.6 112.1s0-2.7.7-3.6c.8-1.1 2-1.2 2.6-1s1.4.8 1.3 2.8-.7 2.8 0 3.6c.5.7.6 1.2 1.7 1q1.6-.1 1.3-1.5c-.3-1.4-.5 0-.7-.8s1-4.6.8-6.9c-.2-2.2-1-4-2.8-4.5q-2.3-.8-4.5.7c-1.4 1-3.3 4.5-3.3 4.5v7.5l3-.2v-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M295 114.1s-1.2-2.5-2-3a3 3 0 0 0-2.8 0c-.6.5-1 1.4-.1 3.1s1.7 2.4 1.4 3.3c-.2.9 0 1.4-1.1 1.7q-1.6.5-1.9-1c-.2-1 .6 0 .4-1-.1-.8-2.8-3.7-3.5-5.9q-1.2-3.3.8-5.2 1.8-1.6 4.3-1.2c1.8.4 4.9 2.9 4.9 2.9l3 6.8-2.8 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M294.4 92.1s-3 5-2.3 8.8 4.6 12 4.6 12v1l2.2-.2-.5-1.1s1-9.8.4-12.9a33 33 0 0 0-4.4-7.6zm4.7 22.7s1.5 1.7 3.2 2.6c2 .9 2.8 1 3.5.3.6-.4.4-2.2-.3-2.7s-1.4-.2-1.5.3q-.2 1.1-1 .4c-1-.4-3-1.7-3-1.7zm-2.3.4s-.6 2.2-1.8 3.7c-1.4 1.6-2.1 2-3 1.7-.7-.1-1.3-1.8-.9-2.6.4-.7 1.2-.8 1.5-.4q.6 1 1.1 0l2-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M302.4 113.4c.2.6-1.8 1.5-4.3 1.9s-4.6.3-4.8-.4c0-.6 1.9-1.5 4.4-2s4.6-.2 4.7.5"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#fc0",
    stroke: "#000",
    strokeWidth: 1.1
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M345.6 113.2s1-2.5 2-3.1c1.1-.8 2.2-.5 2.7 0 .6.3 1 1.2.3 3-.8 1.7-1.6 2.4-1.4 3.3.3 1 .2 1.4 1.3 1.6q1.7.5 1.8-1c.1-1-.5 0-.4-1 0-.8 2.6-3.9 3.2-6q1-3.5-1-5.3-2-1.6-4.5-.9c-1.7.5-4.7 3.1-4.7 3.1l-2.6 7 2.9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M339.7 113.1s-.2-2.7-.9-3.5c-.9-1.1-2-1.1-2.6-1-.7.3-1.4 1-1.2 2.9.2 2 .8 2.8.3 3.6s-.6 1.2-1.7 1.1q-1.7 0-1.5-1.4c.2-1 .6 0 .8-.9.1-.8-1.3-4.5-1.2-6.8 0-2.2.8-4 2.5-4.6q2.3-1 4.5.5c1.5 1 3.6 4.3 3.6 4.3l.4 7.4h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M346.8 92.3s-4.5 3.6-5.2 7.4.1 12.8.1 12.8l-.3 1 2 .6v-1.2s4.4-8.8 4.9-12a32 32 0 0 0-1.5-8.6zm-3.5 22.9s.8 2.1 2.1 3.5c1.5 1.6 2.2 1.9 3.1 1.6.7-.2 1.1-2 .7-2.6s-1.2-.7-1.5-.3q-.6.9-1.1 0l-2.2-2.6zm-2.3-.5s-1.3 1.9-3 2.8c-1.9 1.1-2.7 1.2-3.5.6-.6-.3-.5-2.1.1-2.7q1.2-.6 1.6.2.3 1 1 .4l2.8-2z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M346.9 115c-.1.7-2.3.8-4.8.3s-4.4-1.4-4.3-2 2.3-.8 4.8-.3 4.4 1.4 4.3 2"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#cca715",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M279 129.9s.6 2 1.7 1c1.2-1.1 17.3-7.5 40-7.5s37.5 6.3 38.4 6.7c.9.3 1.3.8 2 0 .8-1-.7-2.3-.7-2.3s-15.8-6.7-40.4-6.6c-24.7.1-40.6 7.1-40.6 7.1s-1 .8-.3 1.6z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M307.9 139.3s.7-2 2-2.4c1-.3 2.5.7 2.5.7s-1.9-.2-2.5.2c-.5.3-.7 1.2-.7 1.2s.4-.8 1.9-.7h1.6s-2.5.3-3 1 2.3 1 2.3 1-4.5 0-5-.2-1-1.2-2-1c-1 .4-2 1.3-2 1.3s1.1-2 1.8-2 1.2 0 1.8.3zm-16.8 3.6s.3-2 1.5-2.7c1-.5 2.7.2 2.7.2s-2 .2-2.5.6-.4 1.4-.4 1.4.3-.8 1.7-1l1.6-.3s-2.4.7-2.8 1.5c-.5.8 2.5.6 2.5.6s-4.4.8-5 .7c-.7-.2-1.2-1-2.1-.5s-1.8 1.5-1.8 1.5.8-2.1 1.5-2.3 1-.2 1.8 0zm30.9-4.3s.8-2 2-2.3 2.7.8 2.7.8-2-.3-2.6 0c-.5.3-.7 1.2-.7 1.2s.4-.7 1.9-.5l1.6.1s-2.5 0-3.1.8c-.6.6 2.3 1.1 2.3 1.1s-4.5-.2-5-.5-1-1.2-2-1-2 1-2 1 1.2-1.8 1.9-1.8 1.1 0 1.8.4zm14.1 1.6s1-1.9 2.4-2c1-.2 2.4 1 2.4 1s-1.8-.4-2.5-.2-.9 1-.9 1 .5-.6 2-.3l1.6.4s-2.5-.2-3.2.4 2.1 1.4 2.1 1.4-4.4-.8-5-1.1c-.4-.4-.7-1.4-1.7-1.3s-2.2.8-2.2.8 1.5-1.6 2.2-1.5q1 0 1.7.5zm14 2.5s1-1.4 2.1-1.5c.9 0 1.9 1.1 1.9 1.1s-1.5-.5-2-.4-.8.8-.8.8.5-.5 1.6-.1l1.3.4s-2-.4-2.6 0 1.6 1.4 1.6 1.4-3.5-1-4-1.3c-.3-.3-.4-1.1-1.2-1.1-.9 0-1.9.5-1.9.5s1.3-1.3 1.9-1.1q.7 0 1.3.5z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#0f6545",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M305 129.7c.4 1.7-1.6 3.5-4.4 4s-5.3-.3-5.6-2 1.6-3.4 4.4-4 5.3.3 5.6 2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#cecfc1",
    d: "M298.8 129.4q0 .7-1 1-1 .1-1.3-.5 0-.7 1-1 1 0 1.3.5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#0f6545",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M344.1 131.8c-.5 1.6-3 2.2-5.8 1.4s-4.4-2.9-4-4.5c.6-1.6 3.2-2.3 5.9-1.4s4.5 2.8 4 4.4z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#cecfc1",
    d: "M338.8 128.5q-.3.7-1.3.4-1-.4-.9-1 .3-.7 1.3-.5 1 .4.9 1z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f2d86",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "M314.6 126h10.1v5h-10.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#707c8b",
    d: "M318.9 127q0 .5-1 .5c-1 0-1-.2-1-.5q.1-.4 1-.4 1.2 0 1 .4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#9f1209",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "m286 131 1.6 5-3 1.7s-1.5 1-3 .2c-1.4-.7-2.2-3-1.4-4 1.5-1.8 5.7-3 5.7-2.9z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#8f322f",
    d: "M283.4 134.6q-.1 1.3-1.5 1.5c-1.4.2-1.4-.7-1.4-1.5q.1-1.4 1.4-1.5c1.3-.1 1.5.6 1.5 1.5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2a494",
    d: "m282 134-.2.7h-.5l-.4-.5.2-.7.5-.1q.4 0 .4.6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#9f1209",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "m353.9 131.7-1.7 4.4 4 2s1.7.8 2.8-.1 1.2-2.8.4-3.7-5.6-2.6-5.5-2.6z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#aa675d",
    d: "M358.6 135.2q-.1 1-1.3 1c-1.2 0-1.2-.4-1.2-1s.6-1 1.2-1q1.2.1 1.3 1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2a494",
    d: "M357.4 135q0 .5-.3.7h-.6l-.3-.6q0-.5.3-.6h.6q.3 0 .3.6z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5d8bc",
    d: "M328.6 126.4a1 1 0 0 1-.8.7 1 1 0 0 1-.7-.7 1 1 0 0 1 .7-.7q.7 0 .8.7m4.3.2a1 1 0 0 1-.7.7 1 1 0 0 1-.8-.7 1 1 0 0 1 .8-.6q.6 0 .7.6m-2.2 1.7q0 .8-1 .9c-1 .1-.8-.4-.8-.9s.4-.9.9-.9.9.4.9 1zm2 2.8a1 1 0 0 1-.6.7 1 1 0 0 1-.8-.7 1 1 0 0 1 .7-.7q.8 0 .8.7zm-4.1-.5a1 1 0 0 1-.7.7 1 1 0 0 1-.7-.7 1 1 0 0 1 .7-.7q.6 0 .7.7m-20.9-3.5a1 1 0 0 1-.5.8 1 1 0 0 1-.9-.5 1 1 0 0 1 .6-.8 1 1 0 0 1 .8.5m4.3-.7a1 1 0 0 1-.6.8 1 1 0 0 1-.8-.5 1 1 0 0 1 .5-.8 1 1 0 0 1 .9.5m-1.8 2.1q0 .9-.6 1a1 1 0 0 1-1.1-.6c-.1-.4.2-1 .7-1a1 1 0 0 1 1 .6m2.7 2.3a1 1 0 0 1-.5.8 1 1 0 0 1-.9-.5 1 1 0 0 1 .5-.8 1 1 0 0 1 .9.5m-4.2.4a1 1 0 0 1-.5.8 1 1 0 0 1-.9-.5 1 1 0 0 1 .6-.8 1 1 0 0 1 .8.5m-19.2-.2a1 1 0 0 1-.4 1 1 1 0 0 1-.9-.4 1 1 0 0 1 .4-1 1 1 0 0 1 1 .4zm4.1-1.3a1 1 0 0 1-.4 1 1 1 0 0 1-.9-.5 1 1 0 0 1 .4-.9 1 1 0 0 1 1 .4zm-1.4 2.4a1 1 0 0 1-.5 1 1 1 0 0 1-1.1-.4 1 1 0 0 1 .5-1.1 1 1 0 0 1 1.1.5m3 1.8a1 1 0 0 1-.4 1q-.6 0-1-.5c-.4-.5.1-.7.5-.9a1 1 0 0 1 .9.4m-4.1 1a1 1 0 0 1-.4 1 1 1 0 0 1-1-.4.7.7 0 0 1 .5-1 1 1 0 0 1 1 .4zm56.2-5.8q-.2.6-1 .5a1 1 0 0 1-.5-1q.1-.5 1-.4.6.2.5.9m4.4 1.3q-.1.7-.9.6a1 1 0 0 1-.6-1q.2-.6 1-.5.6.2.5 1zm-2.7 1.2a1 1 0 0 1-1.1.7 1 1 0 0 1-.8-1.1 1 1 0 0 1 1.2-.7q.8.3.7 1.1m1.5 3.5q-.2.6-1 .5a1 1 0 0 1-.5-.9q.1-.6.9-.5.7.2.6 1zm-4.3-1.6q-.2.6-.9.5a1 1 0 0 1-.5-.9q.2-.6.9-.5.6.2.5.9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M356 89s-2 1.9-4.5 1.9a7 7 0 0 1-4.6-1.6c-.8-.5.2-2 .2-2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.1,
    d: "M312.9 92.8s-3.7-.7-5.3-1.2-1.1-1.5-3-1.4c-1.7.1-3.5 1.4-3.1 3.2s1.7 2 3 1.7c1.2-.4.8-2.6-.8-2.4-1.7 0-.3 1.5-.3 1.5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M287.3 90s1 1.5 3.7 1.2c2.7-.2 3.7-1.6 3.8-2.3.2-.6 0-1.8-.5-2.3s-2.3-.7-2.3-.7"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    stroke: "#161111",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M339.2 270.4c2.5-2.5 6.5-5.2 8.7-11 2-5.6 3-15.7 5-20.8 2.5-8.8 7.5-17.4 1.5-16.8-5.7.6-7.5 6-9.6 10-1 1.5-3.3 4.7-3.7 6.5-.1-3-1.7-11.9-2-20.8-.3-8.4 0-17-.3-20.3-.2-4.3-.2-8.3-1.2-11.4-.5-1.5-2.6-3-3.8-2.9-2.2 0-3.6 2-4 3.9l-.2 2.8c-.2 2.4 0 5.5-.2 8.3-.1 3 .2 6.2 0 9-.2 5.4-.6 10.5-.8 11.5 0-2-1-11.7-1.3-20.9l-.2-10c0-2.6 0-5.4-.2-7.4q-.6-5-4-5c-1.8 0-4.2 1.3-5 5q-.4 3.2-.3 7.4l.2 8c-.2 10.5-.4 21.5-.8 24.8 0-1-1.1-6.5-1.4-13.9l-.4-9.6-.3-9.6c0-1.6-.7-6.2-3.7-6-1.7-.2-3.4 1-4 5.3-.4 2.5-.4 6.6-.5 9.9-.1 6-.4 11.4 0 16.9l.1 7.7c0 .4-.9-2.9-1.3-7.4l-.8-8.6c0-2.3-.1-5.7-.3-8.5-.2-2.1-.1-4.5-2.5-4.3-2.4.1-3.8 1-4.3 5-.4 2.7-.4 8.5-.5 10.5.2 5.3-1.2 17.7-1.8 21.2-.2 2.5-1.2 5.7-1.6 9.2a70 70 0 0 0 1 20.6c2 7 7 10.2 6.8 15s0 13.3 0 17c0 3.8 3.3 4 10 2.6 11.2-2.4 17.3 2.4 26.4-1.2-1.1-10.4 1.1-16.7 1-20.5zm-6.5-24.7c2.3-6.4 5.2-8.9 8-10.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M307.4 239.2q5.2-2 10.6-3.6c4.3-1.2 8.5-3 13-3.6q3-.9 6.4-1m-36.1 42c.4-.3 1 .2 1.4.3q1 .4 2 .3h4q2.5.1 4.3-1m10 .6 1.6.9c.8.3 1.8.4 7.3 0 3.5.2 6.5-2.8 7.4-3.6"
  }))));
};
export default SvgGbNir;